<div class="avatar">
  <span>{{getUserInitials()}}</span>
</div>
